import React, { useState, useEffect } from "react";
import { Button, Form, Image, Table } from "react-bootstrap";
import { toast } from "react-toastify";
import { CustomModal } from "../../components";
import {
  useCreateBannerMutation,
  useDeleteBannerMutation,
  useFetchAllBannersQuery,
  useUpdateBannerMutation,
  useFetchBannerVotesQuery,
} from "../../store/api/apiSlice";
import { Button as CustomBtn } from "../../ui";
const BannersManagement = () => {
  const [currentBannerId, setCurrentBannerId] = useState(null);
  const { data: bannersData = { banners: [] }, refetch } =
    useFetchAllBannersQuery();
  const { data: bannersDataVotes = { banners: [] } } = useFetchBannerVotesQuery(
    currentBannerId,
    {
      skip: !currentBannerId,
    }
  );

  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const sortedBanners = [...bannersData.banners].sort((a, b) => {
    const updatedAtA = new Date(a.updatedAt);
    const updatedAtB = new Date(b.updatedAt);
    if (updatedAtA > updatedAtB) return -1;
    if (updatedAtA < updatedAtB) return 1;

    return 0;
  });
  const paginatedUsers = sortedBanners.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(sortedBanners.length / itemsPerPage);
  const [createBanner] = useCreateBannerMutation();
  const [updateBanner] = useUpdateBannerMutation();
  const [deleteBanner] = useDeleteBannerMutation();
  const [saveButton, setSaveButton] = useState(false);

  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentBanner, setCurrentBanner] = useState(null);
  const [currentVote, setCurrentVote] = useState(null);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [isVoteModalOpen, setIsVoteModalOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [voteTitles, setVoteTitles] = useState([]);
  const [enableFeedback, setEnableFeedback] = useState(false);

  const [title, setTitle] = useState("");
  const [narrative, setNarrative] = useState("");
  const [type, setType] = useState("");

  const [expiryDate, setExpiryDate] = useState("");
  const [url, setUrl] = useState("");

  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const baseUrl = process.env.REACT_APP_SERVER_URL;
  const [voteCounts, setVoteCounts] = useState({});

  useEffect(() => {
    const fetchVoteCounts = async () => {
      const xAuthToken =
        JSON.parse(localStorage.getItem("token") || "{}")?.token || "";
      const headers = {
        "secret-key": process.env.REACT_APP_SECRET_KEY || "",
        "x-auth-token": xAuthToken,
      };

      const counts = {};
      for (const banner of bannersData.banners) {
        try {
          const response = await fetch(
            `${baseUrl}/api/votes/get-all?bannerId=${banner._id}`,
            { headers }
          );
          if (response.ok) {
            const votesData = await response.json();
            counts[banner._id] = votesData.votes.length;
          } else {
            toast.error(`Failed to fetch votes for banner ${banner.title}.`);
          }
        } catch (error) {
          toast.error(
            `An error occurred while fetching votes for banner ${banner.title}.`
          );
        }
      }

      setVoteCounts(counts);
    };

    fetchVoteCounts();
  }, [bannersData]);
  const resetFormFields = () => {
    setSaveButton(false);
    setTitle("");
    setNarrative("");
    setType("");

    setExpiryDate("");
    setUrl("");
    setVoteTitles([]);
    setFile(null);
    setFilePreview(null);
  };

  const openModal = (banner = null) => {
    setCurrentBanner(banner);
    setIsEditing(!!banner);
    setModalOpen(true);

    if (banner) {
      setTitle(banner.title);
      setNarrative(banner.narrative);
      setType(banner.type);
      setEnableFeedback(banner.enableFeedback);

      setExpiryDate(banner.expiry_date.split("T")[0]);

      setUrl(banner.url);

      let parsedVoteTitles = [];
      try {
        parsedVoteTitles = JSON.parse(banner.voteTitles[0]);

        parsedVoteTitles = parsedVoteTitles.map((tag) => tag.trim());
      } catch (error) {
        parsedVoteTitles = [];
      }

      setVoteTitles(parsedVoteTitles);

      setFilePreview(`${baseUrl}/${banner.uploadFile}`);
    } else {
      resetFormFields();
    }
  };

  const closeModal = () => {
    setSaveButton(false);
    setModalOpen(false);
    setIsEditing(false);
    setCurrentBanner(null);
    resetFormFields();
  };

  const openViewModal = async (id) => {
    const xAuthToken =
      JSON.parse(localStorage.getItem("token") || "{}")?.token || "";
    const headers = {
      "secret-key": process.env.REACT_APP_SECRET_KEY || "",
      "x-auth-token": xAuthToken,
    };

    try {
      const response = await fetch(`${baseUrl}/api/banners/get-single/${id}`, {
        headers,
      });
      if (response.ok) {
        const data = await response.json();
        setCurrentBanner(data.banner);
        setViewModalOpen(true);
      } else {
        toast.error("Failed to fetch banner details.");
      }
    } catch (error) {
      toast.error("An error occurred while fetching banner details.");
    }
  };
  const openVoteModal = async (id) => {
    setCurrentBannerId(id);
    const xAuthToken =
      JSON.parse(localStorage.getItem("token") || "{}")?.token || "";
    const headers = {
      "secret-key": process.env.REACT_APP_SECRET_KEY || "",
      "x-auth-token": xAuthToken,
    };

    try {
      const response = await fetch(
        `${baseUrl}/api/votes/get-all?bannerId=${id}`,
        {
          headers,
        }
      );

      if (response.ok) {
        const data = await response.json();
        setCurrentVote(data.votes);
        setIsVoteModalOpen(true);
      } else {
        toast.error("Failed to fetch banner details.");
      }
    } catch (error) {
      toast.error("An error occurred while fetching vote details.");
    }
  };
  const closeVoteModal = () => {
    setIsVoteModalOpen(false);
    setCurrentVote(null);
  };
  const closeViewModal = () => {
    setViewModalOpen(false);
    setCurrentBanner(null);
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);

    const reader = new FileReader();
    reader.onloadend = () => setFilePreview(reader.result);
    if (selectedFile) reader.readAsDataURL(selectedFile);
  };

  const handleSubmit = async (e) => {
    setSaveButton(true);

    e.preventDefault();

    const bannerData = new FormData();
    bannerData.append("title", title);
    bannerData.append("narrative", narrative);
    bannerData.append("type", type);

    bannerData.append("expiry_date", expiryDate);
    bannerData.append("url", url);

    const formattedVoteTitles = voteTitles.map((tag) => tag.trim());
    bannerData.append("voteTitles", JSON.stringify(formattedVoteTitles));

    const enableFeedback = document.querySelector(
      'input[name="enableFeedback"]'
    ).checked;
    bannerData.append("enableFeedback", enableFeedback);
    if (file) bannerData.append("uploadFile", file);

    bannerData.forEach((value, key) => {});
    const xAuthToken =
      JSON.parse(localStorage.getItem("token") || "{}")?.token || "";
    const headers = {
      "secret-key": process.env.REACT_APP_SECRET_KEY || "",
      "x-auth-token": xAuthToken,
    };

    try {
      if (isEditing) {
        const response = await fetch(
          `${baseUrl}/api/banners/update/${currentBanner._id}`,
          {
            method: "PUT",
            headers: {
              ...headers,
            },
            body: bannerData,
          }
        );

        if (!response.ok) {
          setSaveButton(false);

          throw new Error("Failed to update banner");
        }
        setSaveButton(false);

        toast.success("Banner updated successfully!");
      } else {
        await createBanner(bannerData).unwrap();
        setSaveButton(false);

        toast.success("Banner created successfully!");
      }
      refetch();
      closeModal();
    } catch (error) {
      console.log(error)
      toast.error(error.data.message);
    }finally{
      setSaveButton(false);
    }
  };
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const handleDelete = async (id) => {
    try {
      await deleteBanner(id).unwrap();
      toast.success("Banner deleted successfully");
      refetch();
    } catch (error) {
      toast.error("Error deleting banner");
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim()) {
      e.preventDefault();
      addTag(inputValue.trim());
      setInputValue("");
    }
  };

  const addTag = (tag) => {
    if (!voteTitles.includes(tag)) {
      setVoteTitles((prevTags) => {
        const updatedTags = [...prevTags, tag];

        return updatedTags;
      });
    }
  };

  const removeTag = (tagToRemove) => {
    setVoteTitles((prevTags) => prevTags.filter((tag) => tag !== tagToRemove));
  };
  const formatDate = (dateString) => {
    const [datePart] = dateString.split("T");
    const [year, month, day] = datePart.split("-");
    return `${day}-${month}-${year}`;
  };
  return (
    <div>
      <div
        className="main_containerAdmin"
      >
        <h3>Banners Management</h3>
        <Button onClick={() => openModal()}>Create Banner</Button>
      </div>
      <Table striped bordered hover responsive className="mt-4">
        <thead>
          <tr>
            <th>Title</th>
            <th>Narrative</th>
            <th>Type</th>
            <th>Expiry Date</th>
            <th>URL</th>
            <th>Total Votes</th>
            <th>Uploaded File</th>
            <th>Created At</th>
            <th>Updated At</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {paginatedUsers?.map((banner) => (
            <tr
              key={banner._id}
              onClick={() => openViewModal(banner._id)}
              style={{ cursor: "pointer" }}
            >
              <td>{banner.title}</td>
              <td>{banner.narrative}</td>
              <td>{banner.type}</td>
              <td>{banner.expiry_date.split("T")[0]}</td>
              <td>
                <a href={banner.url} target="_blank" rel="noopener noreferrer">
                  Link
                </a>
              </td>
              <td>{voteCounts[banner._id] || 0}</td>
              <td>
                {banner.uploadFile && (
                  <Image
                    src={`${baseUrl}/${banner.uploadFile}`}
                    alt="news"
                    width="50"
                    height="50"
                    thumbnail
                  />
                )}
              </td>
              <td>{new Date(banner.createdAt).toLocaleDateString()}</td>
              <td>{new Date(banner.updatedAt).toLocaleDateString()}</td>
              <td>
                <div
                className="admin_Actions_gap"
                >
                  <img
                    className="Update-delete-icon"
                    onClick={(event) => {
                      event.stopPropagation();
                      openVoteModal(banner._id);
                    }}
                    width="30"
                    height="30"
                    src="https://img.icons8.com/ios-glyphs/30/view-details.png"
                    alt="view-details"
                  />
                  <img
                    className="Update-delete-icon"
                    onClick={(event) => {
                      event.stopPropagation();
                      openModal(banner);
                    }}
                    width="30"
                    height="30"
                    src="https://img.icons8.com/ios-glyphs/30/create-new.png"
                    alt="create-new"
                  />

                  <img
                    className="Update-delete-icon"
                    onClick={(event) => {
                      event.stopPropagation();
                      handleDelete(banner._id);
                    }}
                    width="30"
                    height="30"
                    src="https://img.icons8.com/ios-glyphs/30/filled-trash.png"
                    alt="filled-trash"
                  />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="d-flex justify-content-center mt-3">
        {Array.from({ length: totalPages }, (_, index) => (
          <Button
            key={index}
            variant={currentPage === index + 1 ? "primary" : "outline-primary"}
            onClick={() => setCurrentPage(index + 1)}
            className="mx-1"
          >
            {index + 1}
          </Button>
        ))}
      </div>
      {isModalOpen && (
        <CustomModal isOpen={isModalOpen} onClose={closeModal}>
          <div
           className="admin_CreateModal"
          >
            <h3 className="bannerManangment_CreateModal_title">
              {isEditing ? "Update Banner" : "Create Banner"}
            </h3>
            <Form
              onSubmit={handleSubmit}
              className="admin_CreateModal_submit"
            >
              <Form.Group>
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  required
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Narrative</Form.Label>
                <Form.Control
                  type="text"
                  value={narrative}
                  onChange={(e) => setNarrative(e.target.value)}
                  required
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Type</Form.Label>
                <Form.Select
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  required
                >
                  <option value="">Select Type</option>
                  <option value="Poll">Poll</option>
                  <option value="Survey">Survey</option>
                  <option value="Other">Other</option>
                </Form.Select>
              </Form.Group>

              <Form.Group>
                <Form.Label>Expiry Date</Form.Label>
                <Form.Control
                  type="date"
                  value={expiryDate}
                  onChange={(e) => setExpiryDate(e.target.value)}
                  required
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>URL</Form.Label>
                <Form.Control
                  type="text"
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group className="pb-4" controlId="tags">
                <Form.Label>Vote Titles</Form.Label>
                <div
                  className="bannerManangment_form_votes"
                >
                  {voteTitles.map((tag, index) => (
                    <span
                      key={index}
                      className="bannerManangment_span"
                    >
                      {tag}
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          removeTag(tag);
                        }}
                       className="bannerManangment_removetag"
                      >
                        x
                      </div>
                    </span>
                  ))}
                  <input
                    type="text"
                    placeholder="Enter tags"
                    value={inputValue}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    style={{
                      border: "none",
                      outline: "none",
                      flex: "1",
                      minWidth: "100px",
                      padding: "6px 18px",
                    }}
                  />
                </div>
              </Form.Group>
              <Form.Group>
                <label
                  className="bannerManangment_label"
                >
                  <input
                    type="checkbox"
                    name="enableFeedback"
                    checked={enableFeedback}
                    onChange={(e) => setEnableFeedback(e.target.checked)}
                    style={{
                      marginRight: "8px",
                      marginLeft: "8px ",
                      accentColor: "#ce1126",
                    }}
                  />
                  <span className="bannerManangment_SpanText">Show feedback area</span>
                </label>
              </Form.Group>
              <Form.Group>
                <Form.Label>Upload File</Form.Label>
                <Form.Control type="file" onChange={handleFileChange} />
                {filePreview && (
                  <div className="mt-2">
                    <p>File Preview:</p>
                    <Image
                      src={filePreview}
                      alt="File Preview"
                      thumbnail
                      width="100"
                    />
                  </div>
                )}
              </Form.Group>
              <div className="bannerManangment_form_submit">
                <CustomBtn
                  loading={saveButton}
                  type="submit"
                  variant="primary"
                  style={{ marginTop: "15px" }}
                >
                  {isEditing ? "Update" : "Create"}
                </CustomBtn>
              </div>
            </Form>
          </div>
        </CustomModal>
      )}

      {isViewModalOpen && (
        <CustomModal isOpen={isViewModalOpen} onClose={closeViewModal}>
          <div className="bannerManangment_detail_form">
            <h3>Banner Details</h3>
            <p>
              <strong>Title:</strong> {currentBanner?.title}
            </p>
            <p>
              <strong>Narrative:</strong> {currentBanner?.narrative}
            </p>
            <p>
              <strong>Type:</strong> {currentBanner?.type}
            </p>
            <p>
              <strong>Expiry Date:</strong>{" "}
              {currentBanner?.expiry_date
                ? formatDate(currentBanner.expiry_date)
                : "N/A"}
            </p>
            <p>
              <strong>URL:</strong>{" "}
              <a
                href={currentBanner?.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {currentBanner?.url}
              </a>
            </p>
            <p>
              <strong>Vote Titles:</strong>{" "}
              {currentBanner?.voteTitles.join(", ")}
            </p>
            {currentBanner?.uploadFile && (
              <div className="mt-2">
                <p>
                  <strong>Uploaded File:</strong>
                </p>
                <Image
                  src={`${baseUrl}/${currentBanner.uploadFile}`}
                  alt="Uploaded File"
                  thumbnail
                  width="200"
                />
              </div>
            )}
          </div>
        </CustomModal>
      )}
      {isVoteModalOpen && (
        <CustomModal
          isOpen={isVoteModalOpen}
          onClose={closeVoteModal}
          style={{ overflowX: "unset", maxWidth: "min-content" }}
        >
          <div className="bannerManangment_VoteDetail">
            <h3>Vote Details</h3>
            {bannersDataVotes?.voteCounts?.map((vote) => (
              <h5 key={vote.voteFor}>
                {vote.voteFor}: {vote.count}
              </h5>
            ))}
            <Table
              striped
              bordered
              hover
              responsive
              className="mt-4"
              style={{ overflowX: "unset" }}
            >
              <thead>
                <tr>
                  <th>User Name</th>
                  <th>Vote FeedBack</th>
                  <th>Vote For</th>
                  <th>Created At</th>
                  <th>Updated At</th>
                </tr>
              </thead>
              <tbody>
                {currentVote.length > 0 ? (
                  currentVote.map((vote) => (
                    <tr key={vote._id}>
                      <td>{`${vote?.userId?.firstName} ${vote?.userId?.lastName}`}</td>
                      <td>{vote.voteFeedback}</td>
                      <td>{vote.voteFor}</td>
                      <td>{new Date(vote.createdAt).toLocaleString()}</td>
                      <td>{new Date(vote.updatedAt).toLocaleString()}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="bannerManangment_NoData_found">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default BannersManagement;
